import zipcodes from 'zipcodes';
import { Option } from './types';

export const searchCitiesByName = (partialName: string): Option[] => {
  const lower = partialName.toLowerCase();
  const seen = new Set<string>();
  const matches: Option[] = [];

  const codes = Object.values(zipcodes.codes);

  for (let i = 0; i < codes.length; i += 1) {
    const info = codes[i];
    if (info.country === 'US' && info.city.toLowerCase().includes(lower) && !seen.has(info.city)) {
      seen.add(info.city);
      matches.push({ key: info.city, label: info.city });
      if (matches.length >= 5) return matches;
    }
  }

  return matches;
};
